import React from 'react';
import StyledComponent from '~/components/Styled/Styled';

import css from './LoadingSpinner.scss';

const LoadingSpinner = ({ SpinnerType = 'circle_spin' }) => {
  switch (SpinnerType) {
    case 'square_flip':
      return <div className={css.squareFlip} />;

    case 'square_grid':
      return (
        <div className={css.squareGrid}>
          <div className={`${css.squareGrid} ${css.squareGrid1}`} />
          <div className={`${css.squareGrid} ${css.squareGrid2}`} />
          <div className={`${css.squareGrid} ${css.squareGrid3}`} />
          <div className={`${css.squareGrid} ${css.squareGrid4}`} />
          <div className={`${css.squareGrid} ${css.squareGrid5}`} />
          <div className={`${css.squareGrid} ${css.squareGrid6}`} />
          <div className={`${css.squareGrid} ${css.squareGrid7}`} />
          <div className={`${css.squareGrid} ${css.squareGrid8}`} />
          <div className={`${css.squareGrid} ${css.squareGrid9}`} />
        </div>
      );

    case 'circle_pulse':
      return (
        <div className={css.circlePulse}>
          <div className={css.doubleBounce1} />
          <div className={css.doubleBounce2} />
        </div>
      );

    case 'circle_spin':
      return (
        <div className={css.loadingSpinner}>
          <div />
          <div />
          <div />
          <div />
        </div>
      );

    default:
      return null;
  }
};

LoadingSpinner.displayName = 'LoadingSpinner';

export default StyledComponent(LoadingSpinner, [css]);
